import { Box } from '@givebutter/primitives/box';
import * as ButtonGroup from '@givebutter/primitives/button-group';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Input from 'components/input';
import {
    PaidItemsFilter,
    useItemFulfillment,
} from 'components/pages/campaign-settings/campaign-auction/item-fulfillment/useItemFulfillment';
import * as Table from 'components/table';
import { IntercomProductTourTargets } from 'constants/intercom';

const ItemFulfillment = () => {
    const { table, paidItemsFilter, setPaidItemsFilter, search, setSearch, searchTerm, isPending } =
        useItemFulfillment();

    return (
        <div className={'flex flex-col gap-y-4'}>
            <p
                data-intercom-target={IntercomProductTourTargets.AuctionFulfillmentTitle}
                className={'text-2xl font-medium'}
            >
                Item fulfillment
            </p>
            <div className={'flex justify-between'}>
                <Input.Root className={'w-80'}>
                    <FontAwesomeIcon icon={faSearch} className={'text-gray-300'} />
                    <Input.Form
                        placeholder={'Search'}
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                    />
                </Input.Root>
                <ButtonGroup.Root
                    type="single"
                    value={paidItemsFilter}
                    onValueChange={(value: PaidItemsFilter) => setPaidItemsFilter(value)}
                >
                    <ButtonGroup.Item value={'unfulfilled'}>Unfulfilled</ButtonGroup.Item>
                    <ButtonGroup.Item value={'fulfilled'}>Fulfilled</ButtonGroup.Item>
                    <ButtonGroup.Item value={'all'}>View all</ButtonGroup.Item>
                </ButtonGroup.Root>
            </div>
            <Table.Root
                isLoading={isPending}
                table={table}
                searchTerm={searchTerm}
                variant="bordered"
            >
                <Box className="overflow-x-auto">
                    <Table.Content>
                        <Table.Header />
                        <Table.Body />
                    </Table.Content>
                    <Table.Empty variant={'secondary'}>
                        <Table.EmptyIcon />
                        <Table.EmptyTitle>No fulfillment items found</Table.EmptyTitle>
                    </Table.Empty>
                </Box>
                <Table.Pagination>
                    <Table.PaginationPageNavigation />
                </Table.Pagination>
            </Table.Root>
        </div>
    );
};

export { ItemFulfillment };
